// POST /api/timesheets/generate
export interface GenerateTimesheetsParams {
  periodStartDate: string; // DateOnly (yyyy-MM-dd)
  periodEndDate: string; // DateOnly (yyyy-MM-dd)
  facilityId?: string;
}

export interface GenerateTimesheetsResponse {
  message: string;
}
